import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { HITSEARCH } from 'actions/Base';

export const INITIAL_STATE = {
  searchString: [],
  result: null,
  isLoading: false,
};

export const onGetRequest = (state, { params }) => ({ ...state, isLoading: true, searchString: [params] });
export const onGetFailure = (state) => ({ ...state, isLoading: false });
export const onGetSuccess = (state, { payload }) => ({ ...state, isLoading: false, result: payload });

export const onGetNextRequest = (state, { params }) => ({ ...state, isLoading: true, searchString: [params] });
export const onGetNextFailure = (state) => ({ ...state, isLoading: false });
export const onGetNextSuccess = (state, { payload }) => {  
  const newContent = [...state.result.content]
  payload.content.forEach(object => {
    newContent.push(object);
  })

  return {
    ...state,
    isLoading: false,
    result: {
        ...state.result,
        ...payload,
        content: newContent
    }
  }
};

export const onResetRequest = () => INITIAL_STATE;

export const ACTION_HANDLERS = {
  [HITSEARCH.GET_REQUEST]: onGetRequest,
  [HITSEARCH.GET_FAILURE]: onGetFailure,
  [HITSEARCH.GET_SUCCESS]: onGetSuccess,

  [HITSEARCH.GET_NEXT_REQUEST]: onGetNextRequest,
  [HITSEARCH.GET_NEXT_FAILURE]: onGetNextFailure,
  [HITSEARCH.GET_NEXT_SUCCESS]: onGetNextSuccess,

  [HITSEARCH.RESET_REQUEST]: onResetRequest,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
